import React from 'react'
import "../top_ratting/TopRatting.css"
import ReusableTopRatting from '../organic9-reusable/ReusableTopRatting'
import { Container, Row } from 'react-bootstrap'
const TopRatting = () => {
  return (
    <>
      <section id="top_ratting">
        <Container>
          <h1>Top Ratting Products</h1>
          <Row className='pt-4' style={{rowGap: '40px'}}>
            <ReusableTopRatting img="imeges/desktop 9/saind (foot).svg"/>
            <ReusableTopRatting img="imeges/desktop 9/red saind (foot).svg"/>
            <ReusableTopRatting img="imeges/desktop 9/Apricot.svg"/>
            <ReusableTopRatting img="imeges/desktop 9/Onion.svg"/>
          </Row>
        </Container>
  </section>

    </>
  )
}

export default TopRatting